import React from 'react';
import { Tooltip } from '@getro/rombo';
import PropTypes from 'prop-types';

export const DynamicTooltip = ({ trigger, children, useTooltip, ...props }) =>
  useTooltip ? <Tooltip trigger={trigger || children} {...props} /> : trigger || children;

DynamicTooltip.propTypes = {
  trigger: PropTypes.node,
  useTooltip: PropTypes.bool,
  children: PropTypes.node,
};

DynamicTooltip.defaultProps = {
  useTooltip: true,
  trigger: null,
  children: null,
};

export default DynamicTooltip;
